import { School } from './school';
export class Responsible {
  id: number;
  username: string;
  password: string;
  passwordBrute: string;
  name: string;
  phone: string;
  infos: string;
  expiration: string;
  isActive: boolean;
  isDemo: boolean;
  isRespAdmin: boolean;
  opEmailAlert: boolean;
  email: string;
  opMobileNotification: boolean;
  token: string;
  opDailyReport: boolean;
  RJEmail1: string;
  RJEmail2: string;
  lastConnection: string;
  connectionCounter: number;
  image: string;
  versionApp: string;
  schoolId: number;
  School: School;
  pack: string;

  constructor() {
    this.isActive = true;
    this.isDemo = false;
    this.opEmailAlert = false;
    this.opMobileNotification = false;
    this.opDailyReport = false;
    this.versionApp = '';
    this.School = new School();
    this.pack = '3';
    this.isRespAdmin = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/models/responsible.ts